import React from "react"
import { Switch, Route, withRouter } from "react-router-dom"

import Index from "Components/Admin/Group/Index"

import { URI_LIST } from "constructs"

const Group = () => <Switch><Route exact path={URI_LIST.admin.group.index}><Index /></Route></Switch>

export default withRouter(Group)